import { createStore } from 'vuex'


export default createStore({
  state: {
    token:'',
    pageData: [],
  },
  mutations: {
    setToken(state, token) {
       state.token = token;
       sessionStorage.setItem('token', token);
    },
    setData(state, arr) {
      state.pageData = arr
    }
    
  },
  getters: {
    getToken: (state) => {
      return state.token
    },
    getData: (state) => {
      return state.pageData
    }
  }
})
